import { loadScript, noAttrs } from "./lib/load-script.js";

loadScript("https://fast.wistia.com/assets/external/E-v1.js", noAttrs, {
  onload,
});
